// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles_progressContainer__C3pLp","progressBar":"styles_progressBar__4SGNY"};